<script>
    export default {
        props: [
            'twoFactorAuthEnableRoute',
            'twoFactorAuthGenerateSecretAndQrCodeRoute',
        ],
        data() {
            return {
                qrCode: '',
                google2aSecret: '',
                totp: '',
                errors: '',
            }
        },
        mounted(){
            $('#twoFactorAuthCheckbox').change( ()=> {
                if($('#twoFactorAuthCheckbox').prop('checked')) {
                    $('#twoFactorAuthEnableModal').modal('show')
                    this.getGoogle2FASecretAndQrCode()
                }
            })
            $('#twoFactorAuthEnableModal').on('hidden.bs.modal', () => {
                $('#twoFactorAuthCheckbox').bootstrapToggle('off')
            })
        },
        methods: {
            getGoogle2FASecretAndQrCode(){
                axios.get(this.twoFactorAuthGenerateSecretAndQrCodeRoute)
                    .then(response => {
                        this.qrCode = response.data.qrCode
                        this.google2aSecret = response.data.google2aSecret
                    })
            },
            enable2FA(){
                axios.post(this.twoFactorAuthEnableRoute, {
                    google2fa_secret: this.google2aSecret,
                    totp: this.totp
                })
                    .then(response => {
                        location.reload()
                    })
                    .catch(error => {
                        this.errors = error.response.data
                    })
            },
            cancel(){
                this.errors = ''
                this.totp = ''
            },
            errorsForInput(input){
                if (this.errors.errors && input in this.errors.errors){
                    return this.errors.errors[input][0]
                }
            },
        }
    }
</script>
